import Slider from "../components/Slider"

const Home = () =>{
    return(
        <Slider/>
    )


}

export default Home